var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFunnelPlotIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2216_624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.176 0H0.316406V17.2087H52.176V0Z",
    fill: "#8CBFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7132 17.2085H7.79297V34.4172H44.7132V17.2085Z",
    fill: "#3B82C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8454 34.4282H17.6367V51.6369H34.8454V34.4282Z",
    fill: "#2B6299"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2216_624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.8596,
    height: 51.6371,
    fill: "white",
    transform: "translate(0.316406)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelPlotIcon);
export default __webpack_public_path__ + "static/media/funnel_plot_icon.48459024.svg";
export { ForwardRef as ReactComponent };